<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { useFormModel } from "@/hooks";
import { debounce } from "@/utils";
import { watch } from "vue";

const props = defineProps<{ modelValue?: string }>();
const emit = defineEmits(["change"]);

const emitChange = debounce(() => emit("change", props.modelValue), 500);
watch(
  () => props.modelValue,
  (value) => emitChange()
);

const { setFormModel } = useFormModel();
defineExpose({ setFormModel });
</script>
<template>
  <nut-input :model-value="modelValue" v-bind="$attrs">
    <template #clear v-if="$slots.clear">
      <slot name="clear" />
    </template>
    <template #left v-if="$slots.left">
      <slot name="left" />
    </template>
    <template #right v-if="$slots.right">
      <slot name="right" />
    </template>
  </nut-input>
</template>
